import React, { ReactNode } from 'react';
import { containers } from '@ecosystem/newron-design-system';

const { Tiles } = containers;

interface WithTilesProps {
  children: ReactNode;
}

export const WithTiles: React.FC<WithTilesProps> = ({ children }) => {
  return <Tiles>{children}</Tiles>;
};
